import React from "react";
import SaveBadge from "../components/SaveBadge";
import ActionMenu from "../components/ActionMenu";
import { Segmented, ColorBtn, Chip, LibIcon, Tag, Author, Btn, StarBtn, FavChip } from "../components/ui";
import { libFavKey } from "../lib/favs";
import { fmtDur } from "../lib/blocks";
import { FF, T, EXTRA_LEVEL } from "../lib/constants";
import { BASE_COLORS, EXTRA_COLORS, baseColor, tagsOf, lessonMinutes } from "../lib/library";

// Bibliotheek (build 2.5): losse lessen en oefeningen.
//   Lessen:     Seizoensplan | Club | Mijn lessen     — filter op kleur en type (tags)
//   Oefeningen: Training Deck (alleen Atalanta) | Club | Mijn oefeningen — filter op tags
// Een losse trainer (club.solo) heeft geen Club-tabblad.
export default function Library(props) {
  var mob = props.mob, pd = props.pd;
  var kind = props.kind;
  var notesMode = kind === "notities";
  var src = kind === "lessen" ? props.lesSrc : props.oefSrc;
  var setSrc = kind === "lessen" ? props.setLesSrc : props.setOefSrc;

  var srcOptions = kind === "lessen"
    ? [{ value: "plan", label: "Seizoensplan" }].concat(props.solo ? [] : [{ value: "club", label: "Club" }], [{ value: "mine", label: mob ? "Mijn lessen" : "Mijn lessen" }])
    : (props.hasDeck ? [{ value: "deck", label: "Training Deck" }] : []).concat(props.solo ? [] : [{ value: "club", label: "Club" }], [{ value: "mine", label: "Mijn oefeningen" }]);
  if (!srcOptions.some(function (o) { return o.value === src; })) src = srcOptions[0].value;

  var libKind = kind === "lessen" ? "lesson" : "drill";
  // Favorieten (build 2.6): de chip "★ Favorieten" toont je favorieten uit álle bronnen.
  var isFav = props.isFav || function () { return false; };
  var favOnly = !!props.favOnly;
  var items = [];
  if (favOnly) {
    items = props.libItems.filter(function (x) {
      var ok = kind === "lessen"
        ? (x.src === "plan" || (x.kind === "lesson" && (x.shared || x.ownerUid === props.uid)))
        : (x.src !== "plan" && x.kind === "drill" && (x.shared || x.ownerUid === props.uid));
      return ok && isFav(libFavKey(x));
    });
    if (kind === "oefeningen") items = items.concat(props.deckFavItems || []);
  }
  else if (kind === "lessen" && src === "plan") items = props.libItems.filter(function (x) { return x.src === "plan"; });
  else if (src === "club") items = props.libItems.filter(function (x) { return x.src !== "plan" && x.kind === libKind && x.shared; });
  else if (src === "mine") items = props.libItems.filter(function (x) { return x.src !== "plan" && x.kind === libKind && x.ownerUid === props.uid; });
  function favKeyOf(it) { return it.src === "deck" ? it.favKey : libFavKey(it); }
  function srcLabel(it) {
    if (it.src === "plan") return "Seizoensplan";
    if (it.src === "deck") return "Training Deck · " + (it.secLabel || "");
    if (it.ownerUid === props.uid) return kind === "lessen" ? "Mijn lessen" : "Mijn oefeningen";
    return "Club · " + (it.ownerName || "trainer");
  }
  var listSrc = favOnly ? "fav" : src;

  // Kleurfilter (alleen lessen), daarna tags binnen die kleur.
  var color = kind === "lessen" ? props.color : null;
  var colorItems = color ? items.filter(function (x) { return x.color === color; }) : items;
  var allTags = tagsOf(colorItems);
  var tags = props.tags.filter(function (t) { return allTags.indexOf(t) >= 0; });
  var shown = tags.length ? colorItems.filter(function (x) { return tags.every(function (t) { return (x.tags || []).indexOf(t) >= 0; }); }) : colorItems;
  shown = shown.slice().sort(src === "plan" && !favOnly
    ? function (a, b) { return String(a.planLabel).localeCompare(String(b.planLabel), "nl") || (a.week - b.week) || (a.les - b.les); }
    : function (a, b) { return String(a.name || "").localeCompare(String(b.name || ""), "nl"); });
  // Zonder filters staan je favorieten bovenaan.
  if (!favOnly && !color && !tags.length) {
    shown = shown.filter(function (x) { return isFav(favKeyOf(x)); }).concat(shown.filter(function (x) { return !isFav(favKeyOf(x)); }));
  }
  function star(it, style) {
    if (!props.toggleFav) return null;
    var k = favKeyOf(it);
    return <StarBtn on={isFav(k)} label={it.name || ""} onClick={function () { props.toggleFav(k); }} style={Object.assign({ position: "absolute" }, style)} />;
  }
  var deckList = kind === "oefeningen" && src === "deck" && !favOnly;

  function toggleTag(t) {
    if (tags.indexOf(t) >= 0) props.setTags(tags.filter(function (x) { return x !== t; }));
    else props.setTags(tags.concat([t]));
  }
  var cc = color ? baseColor(color, props.planColors) : null;
  // Filterknoppen: de vijf vaste kleuren, plus oude kleuren (bv. Blauw) als die voorkomen.
  var colorBtns = BASE_COLORS.concat(EXTRA_COLORS.filter(function (c) { return items.some(function (x) { return x.color === c.key; }); }))
    .map(function (c) { return baseColor(c.key, props.planColors); });
  var showNew = !(kind === "oefeningen" && src === "deck");
  var card = { background: T.card, border: "1px solid " + T.line2, borderRadius: 16, boxSizing: "border-box" };

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: (mob ? 12 : 24) + "px " + pd + "px 48px", fontFamily: FF, boxSizing: "border-box", display: "flex", flexDirection: "column", gap: 14 }}>
      <SaveBadge show={props.sav} />
      {!mob && (
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 30, fontWeight: 800, color: T.ink }}>Bibliotheek</h1>
            <p style={{ margin: "4px 0 0", fontSize: 14, color: T.muted }}>Losse lessen en oefeningen, om snel iets te pakken voor op de baan</p>
          </div>
        </div>
      )}

      <div role="tablist" aria-label="Lessen, oefeningen of notities" style={{ display: "flex", borderBottom: "2px solid " + T.line, maxWidth: mob ? "none" : 560 }}>
        {[["lessen", "Lessen"], ["oefeningen", "Oefeningen"], ["notities", "Notities"]].map(function (p) {
          var on = kind === p[0];
          return (
            <button key={p[0]} type="button" role="tab" aria-selected={on} onClick={function () { props.setKind(p[0]); }}
              style={{ flex: 1, minHeight: 46, border: 0, borderBottom: "3px solid " + (on ? T.primary : "transparent"), marginBottom: -2, background: "none", fontSize: 16, fontWeight: on ? 800 : 600, color: on ? T.primary : T.muted, cursor: "pointer", fontFamily: FF }}>{p[1]}</button>
          );
        })}
      </div>

      {kind === "notities" && props.notesContent}
      {kind !== "notities" && <>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        {srcOptions.length > 1 && <div style={{ flex: mob ? "1 1 auto" : "0 1 480px", minWidth: 0, opacity: favOnly ? 0.45 : 1 }} title={favOnly ? "Je ziet favorieten uit alle bronnen" : undefined}>
          <Segmented value={favOnly ? null : src} onChange={function (v) { if (favOnly) props.setFavOnly(false); setSrc(v); }} options={srcOptions} />
        </div>}
        {showNew && (mob
          ? <button type="button" aria-label={kind === "lessen" ? "Nieuwe les" : "Nieuwe oefening"} onClick={function () { props.onNew(libKind); }}
              style={{ width: 44, height: 44, borderRadius: 12, border: 0, background: T.primary, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", cursor: "pointer" }}><LibIcon name="plus" /></button>
          : <Btn onClick={function () { props.onNew(libKind); }} style={{ marginLeft: "auto" }}><LibIcon name="plus" size={16} />{kind === "lessen" ? "Nieuwe les" : "Nieuwe oefening"}</Btn>)}
      </div>

      {/* ----- Training Deck: de secties als mappen ----- */}
      {deckList && (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: mob ? "nowrap" : "wrap", overflowX: mob ? "auto" : "visible", paddingBottom: mob ? 2 : 0 }} className="sp-noscrollbar">
            {props.toggleFav && <FavChip active={false} onClick={function () { props.setFavOnly(true); }} />}
            {props.toggleFav && <span aria-hidden="true" style={{ width: 1, height: 28, background: T.line, margin: "0 2px", flex: "none" }} />}
            {props.dsecs.map(function (l) {
              return <ColorBtn key={l.id} lv={l} active={props.deckSel === l.id} text={l.label} height={40}
                onClick={function () { props.pickSection(l); }} style={{ padding: "0 14px", flex: "none" }} />;
            })}
            {props.canEditDeck && (
              <button type="button" onClick={props.onAddSection} aria-label="Nieuwe sectie" title="Nieuwe sectie"
                style={{ height: 40, minWidth: 40, padding: "0 12px", border: "2px dashed #CFC9BD", borderRadius: 10, background: "transparent", color: T.muted, fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, cursor: "pointer", fontFamily: FF, flex: "none" }}>
                <LibIcon name="plus" size={16} />{mob ? "" : "Sectie"}
              </button>
            )}
            {props.canEditDeck && props.deckSel && (function () {
              var i = props.dsecs.findIndex(function (l) { return l.id === props.deckSel; });
              return <div style={{ position: "relative", width: 36, height: 36, flex: "none" }}><ActionMenu size={36} style={{ position: "absolute", top: 0, right: 0 }} items={[
                { icon: "✎", label: "Naam en kleur van deze sectie", onClick: function () { props.openEditLevel(props.deckSel); } },
                i > 0 && { icon: "←", label: "Eerder zetten", onClick: function () { props.moveLevel(props.deckSel, i - 1); } },
                i >= 0 && i < props.dsecs.length - 1 && { icon: "→", label: "Later zetten", onClick: function () { props.moveLevel(props.deckSel, i + 1); } },
                { icon: "×", label: "Sectie verwijderen", danger: true, onClick: function () { props.confirmDel("level", props.deckSel); } },
              ]} /></div>;
            })()}
          </div>
          {props.dsecs.length === 0 && <p style={{ color: T.muted, fontSize: 14, margin: 0 }}>{props.canEditDeck ? "Nog geen secties. Maak er een met ‘Sectie’." : "De Training Deck is nog leeg."}</p>}
          {props.deckContent}
        </div>
      )}

      {/* ----- Oude lijst extra oefeningen (van vóór 2.5), tot hij is overgezet ----- */}
      {kind === "oefeningen" && src === "club" && !favOnly && props.legacyCount > 0 && (
        <div style={Object.assign({}, card, { padding: "14px 16px", display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", background: T.soft })}>
          <span style={{ width: 40, height: 40, borderRadius: 10, background: EXTRA_LEVEL.bg, color: EXTRA_LEVEL.ink, display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}><LibIcon name="folder" size={20} /></span>
          <div style={{ flex: "1 1 220px", minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: T.ink }}>Extra oefeningen (oude lijst)</div>
            <div style={{ fontSize: 13, color: T.muted }}>{props.legacyCount + (props.legacyCount === 1 ? " oefening" : " oefeningen")}{props.canMigrate ? ". Zet ze over, dan staan ze hier als gedeelde oefeningen met tags." : ""}</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn kind="secondary" onClick={props.openLegacy}>Bekijken</Btn>
            {props.canMigrate && <Btn onClick={props.onMigrate} disabled={props.migrating}>{props.migrating ? "Bezig..." : "Overzetten"}</Btn>}
          </div>
        </div>
      )}

      {/* ----- Filters ----- */}
      {!deckList && (
        <section aria-label="Filters" style={Object.assign({}, card, { padding: mob ? "12px" : "14px 18px", display: "flex", flexDirection: "column", gap: 12 })}>
          {kind === "lessen" && (
            <div style={{ display: "flex", alignItems: mob ? "stretch" : "center", gap: mob ? 6 : 12, flexDirection: mob ? "column" : "row" }}>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: T.muted, width: mob ? "auto" : 52, flex: "none" }}>Kleur</span>
              <div style={{ display: "grid", gridTemplateColumns: mob ? "repeat(3, minmax(0, 1fr))" : "repeat(" + (colorBtns.length + 1) + ", minmax(0, auto))", gap: 6, justifyContent: "start" }}>
                <ColorBtn lv={{ color: "#CFC9BD", on: T.ink, label: "Alle" }} active={!color} onClick={function () { props.setColor(null); }} height={40} style={mob ? null : { padding: "0 14px" }} />
                {colorBtns.map(function (c) {
                  return <ColorBtn key={c.key} lv={c} active={color === c.key} text={mob && c.key === "volwassenen" ? "Volw." : c.label} height={40}
                    onClick={function () { props.setColor(color === c.key ? null : c.key); }} style={mob ? null : { padding: "0 14px" }} />;
                })}
              </div>
            </div>
          )}
          {kind === "lessen" && <div style={{ height: 1, background: T.line }} />}
          {(
            <div style={{ display: "flex", alignItems: mob ? "stretch" : "flex-start", gap: mob ? 6 : 12, flexDirection: mob ? "column" : "row" }}>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: T.muted, width: mob ? "auto" : 52, flex: "none", paddingTop: mob ? 0 : 9 }}>{kind === "lessen" ? "Type" : "Tags"}</span>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {props.toggleFav && <FavChip active={favOnly} onClick={function () { props.setFavOnly(!favOnly); }} />}
                {props.toggleFav && allTags.length > 0 && <span aria-hidden="true" style={{ width: 1, background: T.line, margin: "4px 2px", alignSelf: "stretch" }} />}
                {allTags.map(function (t) {
                  return <Chip key={t} active={tags.indexOf(t) >= 0} color={cc ? cc.ink : T.primary} bg={cc ? cc.bg : "#E9EDF5"} onClick={function () { toggleTag(t); }}>{t}</Chip>;
                })}
              </div>
            </div>
          )}
          {kind === "oefeningen" && allTags.length === 0 && !favOnly && <span style={{ fontSize: 13, color: T.muted }}>Geef oefeningen tags om erop te kunnen filteren.</span>}
          {kind === "lessen" && allTags.length === 0 && !favOnly && colorItems.length > 0 && <span style={{ fontSize: 13, color: T.muted }}>Nog geen tags om op type te filteren.</span>}
        </section>
      )}

      {!deckList && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, color: T.muted, minHeight: 32, gap: 10 }}>
          <span>{props.libLoading
            ? "Laden..."
            : favOnly
              ? <><strong style={{ color: T.ink }}>{shown.length + (shown.length === 1 ? " favoriet" : " favorieten")}</strong>{" uit alle bronnen" + subtitle(kind, "fav", cc, tags)}</>
              : <><strong style={{ color: T.ink }}>{shown.length + " " + (kind === "lessen" ? (shown.length === 1 ? "les" : "lessen") : (shown.length === 1 ? "oefening" : "oefeningen"))}</strong>{subtitle(kind, src, cc, tags)}</>}</span>
          {(color || tags.length > 0 || favOnly) && <button type="button" onClick={function () { props.setColor(null); props.setTags([]); if (favOnly) props.setFavOnly(false); }} style={{ border: 0, background: "none", color: T.primary, fontSize: 13, fontWeight: 700, minHeight: 32, cursor: "pointer", fontFamily: FF }}>Filters wissen</button>}
        </div>
      )}
      {props.libError && <p role="alert" style={{ color: "#B83232", fontSize: 14, margin: 0 }}>{props.libError}</p>}

      {/* ----- Lessen ----- */}
      {kind === "lessen" && (
        <div style={{ display: "grid", gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(auto-fill, minmax(300px, 1fr))", gap: mob ? 10 : 14 }}>
          {shown.map(function (it) {
            var lv = it.level || baseColor(it.color, props.planColors);
            var meta = it.src === "plan" && it.week ? ("Week " + it.week + " · Les " + (it.les ? "B" : "A")) : null;
            var mins = lessonMinutes(it.parts);
            if (mob) return (
              <div key={it.id} style={{ position: "relative" }}>
              <button type="button" onClick={function () { props.onOpen(it); }}
                style={Object.assign({}, card, { borderRadius: 14, display: "flex", gap: 12, alignItems: "center", padding: props.toggleFav ? "12px 52px 12px 12px" : "12px 10px 12px 12px", textAlign: "left", cursor: "pointer", fontFamily: FF, width: "100%" })}>
                <span aria-hidden="true" style={{ width: 26, height: 26, borderRadius: "50%", background: lv.color, flex: "none" }} />
                <span style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 3 }}>
                  <span style={{ fontSize: 16, fontWeight: 800, color: T.ink, lineHeight: 1.25 }}>{it.name || "Naamloze les"}</span>
                  <span style={{ fontSize: 12, color: T.muted }}>{[meta, fmtDur(mins, "min"), (it.tags || []).join(", ")].filter(Boolean).join(" · ")}</span>
                  {listSrc === "fav" && <SrcLine text={srcLabel(it)} />}
                  {it.src !== "plan" && listSrc === "club" && <Author name={it.ownerName} />}
                  {listSrc === "mine" && <ShareBadge shared={it.shared} solo={props.solo} />}
                </span>
                {!props.toggleFav && <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A857B" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true" style={{ flex: "none" }}><path d="M9 18l6-6-6-6" /></svg>}
              </button>
              {star(it, { right: 4, top: "50%", marginTop: -22 })}
              </div>
            );
            return (
              <div key={it.id} style={{ position: "relative", display: "flex" }}>
              <button type="button" onClick={function () { props.onOpen(it); }}
                style={Object.assign({}, card, { flex: 1, minWidth: 0, overflow: "hidden", display: "flex", flexDirection: "column", padding: 0, textAlign: "left", cursor: "pointer", fontFamily: FF })}>
                <span style={{ background: lv.color, color: lv.on || "#fff", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "baseline", fontSize: 13, width: "100%", boxSizing: "border-box", gap: 8 }}>
                  <span style={{ fontWeight: 800, fontSize: 15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{lv.label}</span>
                  <span style={{ whiteSpace: "nowrap" }}>{meta || (listSrc === "mine" ? (it.shared ? "Gedeeld" : "Privé") : "")}</span>
                </span>
                <span style={{ padding: "14px 16px 14px", display: "flex", flexDirection: "column", gap: 8, flex: 1, width: "100%", boxSizing: "border-box" }}>
                  <span style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.25, color: T.ink, paddingRight: props.toggleFav ? 30 : 0 }}>{it.name || "Naamloze les"}</span>
                  {it.sub && <span style={{ fontSize: 13, lineHeight: 1.5, color: "#4A4740" }}>{it.sub}</span>}
                  {(it.tags || []).length > 0 && <span style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{it.tags.map(function (t, j) { return <Tag key={j} text={t} lv={lv} />; })}</span>}
                  <span style={{ marginTop: "auto", paddingTop: 10, borderTop: "1px solid " + T.line, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, fontSize: 12, color: T.muted }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><LibIcon name="clock" size={14} />{fmtDur(mins, "min")}</span>
                    {listSrc === "club" && <Author name={it.ownerName} />}
                    {listSrc === "fav" && <SrcLine text={srcLabel(it)} />}
                  </span>
                </span>
              </button>
              {star(it, { right: 4, top: 42 })}
              </div>
            );
          })}
        </div>
      )}

      {/* ----- Oefeningen (club / mijn) ----- */}
      {kind === "oefeningen" && !deckList && (
        <div style={{ display: "grid", gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
          {shown.map(function (it) {
            return (
              <div key={it.id} style={{ position: "relative", display: "flex" }}>
              <button type="button" onClick={function () { if (it.src === "deck") props.onOpenDeck(it); else props.onOpen(it); }}
                style={Object.assign({}, card, { flex: 1, minWidth: 0, borderRadius: 14, overflow: "hidden", padding: 0, textAlign: "left", cursor: "pointer", display: "flex", flexDirection: mob ? "row" : "column", alignItems: mob ? "center" : "stretch", fontFamily: FF })}>
                <span style={{ width: mob ? 72 : "100%", height: mob ? 72 : 96, flex: "none", background: T.soft, borderRight: mob ? "1px solid " + T.line : "none", borderBottom: mob ? "none" : "1px solid " + T.line, display: "flex", alignItems: "center", justifyContent: "center", color: "#8A857B", overflow: "hidden" }}>
                  {it.photo ? <img src={it.photo} alt="" loading="lazy" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} /> : <LibIcon name={it.diagram ? "court" : "image"} size={22} />}
                </span>
                <span style={{ padding: mob && props.toggleFav ? "12px 48px 12px 14px" : "12px 14px", display: "flex", flexDirection: "column", gap: 6, minWidth: 0, flex: 1 }}>
                  <span style={{ fontSize: 15, fontWeight: 800, color: it.name ? T.ink : "#B5B0A6", lineHeight: 1.25 }}>{it.name || "Naamloze oefening"}</span>
                  {(it.tags || []).length > 0 && <span style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{it.tags.map(function (t, j) { return <Tag key={j} text={t} lv={it.lv || EXTRA_LEVEL} />; })}</span>}
                  {listSrc === "fav" && <SrcLine text={srcLabel(it)} />}
                  {listSrc === "club" && <Author name={it.ownerName} />}
                  {listSrc === "mine" && <ShareBadge shared={it.shared} solo={props.solo} />}
                </span>
              </button>
              {star(it, mob ? { right: 2, top: "50%", marginTop: -22 } : { right: 6, top: 6, width: 40, height: 40, borderRadius: 20, background: "rgba(255,255,255,.92)" })}
              </div>
            );
          })}
        </div>
      )}

      {!props.libLoading && shown.length === 0 && !deckList && (
        <div style={{ textAlign: "center", color: T.muted, fontSize: 14, padding: "28px 12px", border: "2px dashed " + T.line, borderRadius: 16, lineHeight: 1.6 }}>
          {favOnly && !color && !tags.length
            ? "Nog geen favorieten. Tik op het sterretje bij " + (kind === "lessen" ? "een les" : "een oefening") + ", dan staat hij hier."
            : emptyText(kind, src, !!color || tags.length > 0, props.canEditOfficial)}
        </div>
      )}
      </>}
      {props.renderModal()}
    </div>
  );
}

function SrcLine({ text }) {
  return <span style={{ fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: 0.4 }}>{text}</span>;
}

function ShareBadge({ shared, solo }) {
  if (solo) return null;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 700, color: shared ? "#2F7D47" : T.muted }}>
      <LibIcon name={shared ? "share" : "lock"} size={13} />{shared ? "Gedeeld met club" : "Privé"}
    </span>
  );
}

function subtitle(kind, src, cc, tags) {
  var parts = [];
  if (src === "club") parts.push(kind === "lessen" ? "van trainers van je club" : "van trainers van je club");
  if (cc) parts.push(cc.label);
  if (tags.length) parts.push(tags.join(", "));
  return parts.length ? " · " + parts.join(" · ") : "";
}

function emptyText(kind, src, filtered, canEditOfficial) {
  if (filtered) return "Niets gevonden met deze filters.";
  if (kind === "lessen") {
    if (src === "plan") return canEditOfficial
      ? "Nog geen losse lessen. Kopieer een seizoensplan hierheen via het beginscherm: ⋯ bij het plan → ‘Kopiëren naar losse lessen’."
      : "Hier komen binnenkort losse lessen uit de seizoensplannen te staan.";
    if (src === "club") return "Nog geen gedeelde lessen. Maak een les en zet ‘Delen met mijn club’ aan.";
    return "Je hebt nog geen eigen lessen. Maak er een met ‘Nieuwe les’, of kopieer een les uit het seizoensplan.";
  }
  if (src === "club") return "Nog geen gedeelde oefeningen. Maak een oefening en zet ‘Delen met mijn club’ aan.";
  return "Je hebt nog geen eigen oefeningen. Maak er een met ‘Nieuwe oefening’.";
}
